import * as React from "react";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import HomeIcon from "@mui/icons-material/Home";
import { Box } from "@mui/material";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Typography from "@mui/material/Typography";
import PropTypes from "prop-types";
import { Link as RouterLink, useLocation } from "react-router-dom";

const breadcrumbNameMap = {
    "/admin": "Admin",
    "/admin/account": "Account",
    "/admin/account/credit": "Credit",
    "/admin/account/coins": "Coins",
    "/admin/account/leader-board": "Leader Boards",
    "/admin/account/speed-rank": "Speed ranks",
    "/admin/account/subscription": "Subscription Details",
    "/admin/crm": "CRM",
    "/admin/crm/mailing_list": "Mailing List",
    "/admin/crm/contacts": "Contact",
    "/admin/crm/referral": "Referral",
    "/admin/crm/referral/inviters": "Inviters",
    "/admin/crm/feedback": "Feedback",
    "/admin/crm/review": "Review",
    "/admin/mailing_list": "Mailing List",
    "/admin/referral": "Referral",
    "/admin/contacts": "Contacts",
    "/admin/contacts/detail": "Detail",
    "/admin/puzzle": "Puzzle",
    "/admin/puzzle/grid": "Word Grid Directory",
    "/admin/puzzle/grid/detail": "Detail",
    "/admin/puzzle/grid/review": "Review",
    "/admin/puzzle/grid_tpl": "Word Grid Template",
    "/admin/puzzle/grid_pack": "Pack (mini)",
    "/admin/puzzle/grid_tpl/create": "Create",
    "/admin/puzzle/grid_tpl/detail": "Detail",
    "/admin/puzzle/grid_tpl/verify-coord": "Verify Coordinates",
    "/admin/puzzle/grid_play": "Play",
    "/admin/puzzle/grid_board": "Grid Board",
    "/admin/puzzle/grid_board/draft": "Draft",
    "/admin/puzzle/grid_board/draft/edit": "Edit",
    "/admin/puzzle/grid_board/ready-to-review": "Ready to Review",
    "/admin/puzzle/grid_board/reviewed": "Reviewed",
    "/admin/puzzle/grid_board/published": "Published",
    "/admin/puzzle/cross_tpl": "Cross Template",
    "/admin/puzzle/cross_tpl/create": "Create",
    "/admin/puzzle/cross_tpl/detail": "Detail",
    "/admin/puzzle/cross_tpl/verify-coord": "Verify Coordinates",
    "/admin/puzzle/cross_board": "Crossword Board",
    "/admin/puzzle/cross_board/draft": "Draft",
    "/admin/puzzle/cross_board/draft/edit": "Edit",
    "/admin/puzzle/cross_board/ready-to-review": "Ready to Review",
    "/admin/puzzle/cross_board/reviewed": "Reviewed",
    "/admin/puzzle/cross_board/published": "Published",
    "/admin/puzzle/cross_play": "Play",
    "/admin/puzzle/cross_stats": "Stats",
    "/admin/puzzle/grid_stats": "Stats",
    "/admin/puzzle/word_wheel_board": "Word Wheel Board",
    "/admin/puzzle/word_wheel_board/draft": "Draft",
    "/admin/puzzle/word_wheel_board/ready-to-review": "Ready to Review",
    "/admin/puzzle/word_wheel_board/reviewed": "Reviewed",
    "/admin/puzzle/word_wheel_board/published": "Published",
    "/admin/puzzle/word_wheel_tpl": "Word Wheel Template",
    "/admin/puzzle/word_wheel_pack": "Word Wheel Pack",
    "/admin/puzzle/word_wheel_journey": "Journey map",
    "/admin/puzzle/word_wheel_tpl/detail": "Detail",
    "/admin/puzzle/word_wheel_play": "Play",
    "/admin/puzzle/word_wheel_stats": "Stats",
    "/admin/banned": "Banned words",
    "/admin/topic": "Topic",
    "/admin/topic/detail": "Detail",
    "/admin/topic/create": "Create",
    "/admin/genre": "Genre",
    "/admin/system": "System",
    "/admin/system/tag-migration": "Tag migration",
    "/admin/system/anything": "Anything",
    "/admin/advertisement": "AD",
    "/admin/tutor": "Tutor",
    "/admin/tutor/board": "Board",
    "/admin/tutor/history": "History",
    "/admin/advertisement/resources": "Resource",
    "/admin/advertisement/generate": "Generate Media",
    "/admin/advertisement/iphone-background": "App Background",
    "/admin/advertisement/pc-background": "PC background",
    "/admin/advertisement/feature-graphic": "Generate Media",
    "/admin/advertisement/app-icon": "Generate Media",
    "/admin/advertisement/sliding-feature-graphic": "Generate Media",
    "/admin/advertisement/app-screenshot-links": "App & Screenshot Links",
    "/admin/advertisement/social": "Social",
    "/admin/advertisement/social/facebook": "Facebook",
    "/admin/advertisement/social/instagram": "Instagram",
    "/admin/advertisement/social/word-wheel": "Word Wheel",
    "/admin/advertisement/social/word-wheel-grid": "Word Wheel (Grid)",
    "/admin/advertisement/tutors": "Tutor",
    "/admin/advertisement/product-icon": "Product Icon",
    "/admin/advertisement/promotion": "Promotion",
    "/admin/advertisement/promotion/new": "New",
    "/admin/advertisement/stripe-image": "Product Icon",
    "/admin/system/ad": "AD",
    "/admin/system/ad/sliding-feature-graphic": "Generate Media",
    "/admin/system/prototype": "Prototype",
    "/admin/system/integrate": "API Integrations",
    "/admin/system/integrate/dictionary": "Dictionary",
    "/admin/system/integrate/cambridge": "Cambridge",
    "/admin/system/integrate/datamuse": "Datamuse",
    "/admin/system/integrate/guardian": "Guardian",
    "/admin/system/integrate/ingest": "Ingest",
    "/admin/system/integrate/openlibrary": "Open Library",
    "/admin/system/integrate/openlibrary/detail": "Open Library - Detail",
    "/admin/system/integrate/puzzle-interact-api": "Puzzle Interact API",
    "/admin/system/integrate/word-network": "Word Network",
    "/admin/system/anything/test-adsense": "Google AdSense",
    "/admin/system/anything/test-monetag": "Monetag",
    "/admin/system/anything/send-notification": "Send notification",
    "/admin/system/anything/crypto": "Crypto",
    "/admin/system/anything/genre": "Genre",
    "/admin/system/anything/grid": "Grid",
    "/admin/system/anything/credentials": "Credentials",
    "/admin/system/anything/file-upload": "File Upload",
    "/admin/system/anything/email": "Email",
    "/admin/system/anything/dic-play-word": "Play a word",
    "/admin/system/anything/test-instagram": "Test Instagram",
    "/admin/system/anything/test-facebook": "Test Facebook",
    "/admin/system/anything/test-jigsaw-canvas": "Test Jigsaw canvas",
    "/admin/system/anything/test-prompt-v2": "Test new prompt v2",
    "/admin/system/anything/test-word-puzzle-photo": "Test word-puzzle photo prompt",
    "/admin/system/anything/post-word-wheel": "Post Word Wheel puzzle",
    "/admin/story": "Story",
    "/admin/sliding/browse": "Board",
    "/admin/sliding/play": "Play",
    "/admin/sliding/stats": "Stats",
    "/admin/sliding/packs": "Packs",
    "/admin/jigsaw": "Jigsaw",
    "/admin/jigsaw/browse": "Board",
    "/admin/jigsaw/template": "Template",
    "/admin/jigsaw/packs": "Packs",
    "/admin/jigsaw/template/create": "Create Template",
    "/admin/jigsaw/template/edit": "Edit Template",
    "/admin/jigsaw/play": "Play",
    "/admin/jigsaw/stats": "Stats",
    "/admin/feedback": "Feedback",
    "/admin/notification": "Notification",
    "/admin/setting": "Setting",
    "/admin/bedrock-idea": "Bedrock Idea",
    "/admin/bedrock-idea/new": "New Idea",
    "/admin/bedrock-idea/edit": "Edit Idea",
    "/admin/publisher": "Publisher",
    "/admin/publisher/new": "New Schedule",
    "/admin/publisher/edit": "Edit Schedule",
    "/admin/task-scheduler": "Task Scheduler",
    "/admin/task-scheduler/new": "New Task Schedule",
    "/admin/task-scheduler/edit": "Edit Task Schedule",
    "/admin/logs": "Logs",
    "/admin/statistics": "Statistics",
};

const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/;

function ListItemLink(props) {
    const { to, open, ...other } = props;
    const primary = breadcrumbNameMap[to];

    let icon = null;
    if (open != null) {
        icon = open ? <ExpandLess /> : <ExpandMore />;
    }

    return (
        <li>
            <ListItem component={RouterLink} to={to} {...other}>
                <ListItemText primary={primary} />
                {icon}
            </ListItem>
        </li>
    );
}

ListItemLink.propTypes = {
    open: PropTypes.bool,
    to: PropTypes.string.isRequired,
};

function LinkRouter(props) {
    return <Link {...props} component={RouterLink} />;
}

export default function NavigationBar() {
    const location = useLocation();
    const pathnames = location.pathname.split("/").filter((x) => x);

    // List of API path segments that should show "API Integrations" instead of "System"
    const apiSegments = [
        "dictionary",
        "cambridge",
        "datamuse",
        "guardian",
        "openlibrary",
        "puzzle-interact-api",
        "word-network"
    ];

    // Check if current path is an API path
    const isApiPath = apiSegments.some(segment => location.pathname.includes(`/system/integrate/${segment}`));

    return (
        <Box sx={{ marginBottom: 2 }}>
            <Breadcrumbs aria-label="breadcrumb">
                <LinkRouter underline="hover" sx={{ display: "flex", alignItems: "center" }} color="inherit" to="/">
                    <HomeIcon sx={{ mr: 0.5, mt: 0.2 }} fontSize="inherit" />
                    Home
                </LinkRouter>
                {pathnames.map((_value, index) => {
                    const isLast = index === pathnames.length - 1;
                    const isSecondToLast = index === pathnames.length - 2;
                    const lastIsUUID = uuidRegex.test(pathnames[pathnames.length - 1]);
                    const currentIsUUID = uuidRegex.test(pathnames[index]);
                    
                    // Build breadcrumb lookup path by replacing UUIDs with their context
                    // For /draft/{uuid}/edit -> lookup /draft/edit
                    let breadcrumbPath = pathnames.slice(0, index + 1).map((segment) => {
                        if (uuidRegex.test(segment)) {
                            // Skip UUIDs - they'll be replaced by the segment that follows
                            return null;
                        }
                        return segment;
                    }).filter(Boolean);
                    
                    const to = `/${breadcrumbPath.join("/")}`;
                    const actualTo = `/${pathnames.slice(0, index + 1).join("/")}`;

                    // Replace "System" with "API Integrations" for API pages
                    if (isApiPath && pathnames[index] === "system" && index === 1) {
                        const nextSegment = pathnames[index + 1];
                        if (nextSegment === "integrate") {
                            // Show "API Integrations" instead of "System" when on integrate path
                            return (
                                <LinkRouter underline="hover" sx={{ display: "flex", alignItems: "center" }} color="inherit" to="/admin/system/integrate" key="api-integrations">
                                    {breadcrumbNameMap["/admin/system/integrate"]}
                                </LinkRouter>
                            );
                        }
                        return null; // Skip "System" for API paths
                    }

                    if (lastIsUUID && isLast) {
                        // Skip rendering the last element if it is a UUID
                        return null;
                    }

                    if (isSecondToLast && lastIsUUID) {
                        // Handle the second-to-last element as the last element when the last element is a UUID
                        return (
                            <Typography color="text.primary" key={actualTo}>
                                {breadcrumbNameMap[to] || pathnames[index]}
                            </Typography>
                        );
                    }

                    if (currentIsUUID) {
                        // Skip rendering UUID segments
                        return null;
                    }

                    return isLast ? (
                        <Typography color="text.primary" key={actualTo}>
                            {breadcrumbNameMap[to] || pathnames[index]}
                        </Typography>
                    ) : (
                        <LinkRouter underline="hover" sx={{ display: "flex", alignItems: "center" }} color="inherit" to={actualTo} key={actualTo}>
                            {breadcrumbNameMap[to] || pathnames[index]}
                        </LinkRouter>
                    );
                })}
            </Breadcrumbs>
        </Box>
    );
}
